'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMobileView = isMobileView;
exports.default = AppPromo;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMobileView(currentBreakpoint) {
    if ([_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW].includes(currentBreakpoint)) {
        return true;
    }
    return false;
}

function AppPromo() {
    this.$element = (0, _jquery2.default)('.rn-footerAppPromo');
    this.buttonSelector = '.rn-footerAppPromo__button';
    this.hiddenClass = 'rn-footerAppPromo--hidden';
}

AppPromo.prototype.show = function () {
    this.$element.removeClass(this.hiddenClass);
};

AppPromo.prototype.hide = function () {
    this.$element.addClass(this.hiddenClass);
};

AppPromo.prototype.setButtonAndImage = function (deviceType) {
    (0, _jquery2.default)(this.buttonSelector).hide();
    (0, _jquery2.default)(this.buttonSelector + '--' + deviceType).show();

    this.show();
};

AppPromo.prototype.init = function () {
    var self = this;
    var userAgent = window.navigator.userAgent.toLowerCase();

    (0, _jquery2.default)(window).on('rpBreakpointsSwitch', function (event) {
        if (isMobileView(event.detail.breakpoint.code)) {
            if (/android/i.test(userAgent)) {
                self.setButtonAndImage('android');
                return;
            }

            if (/iPhone/i.test(userAgent)) {
                self.setButtonAndImage('iphone');
                return;
            }

            self.hide();
            return;
        }

        self.show();
    });

    if (isMobileView(_rpMqBreakpoints2.default.current().code)) {
        if (/android/i.test(userAgent)) {
            self.setButtonAndImage('android');
            return;
        }

        if (/iPhone/i.test(userAgent)) {
            self.setButtonAndImage('iphone');
            return;
        }
    } else {
        self.show();
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/appPromo/appPromo.js
// module id = 1886
// module chunks = 1